import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { toast } from "react-toastify";
import { useFormik } from "formik";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const SubscriptionAdmin = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [name, setName] = useState("");
  const [ids,setIds]=useState(null)

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const superuserId = localStorage.getItem("is_superuser");
  const StoreID = localStorage.getItem("store_id");

  const subscriptonList = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/product-variants-subscription-list/?store_id=${StoreID}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log("Inventory Data List===>", response?.data?.data);
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    subscriptonList();
  }, []);

  const submitData = () => {
    const fd = new FormData();
    fd.append("subscription_name", name);
    ids === null ?
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/product-variants-subscription-list/?store_id=${StoreID}`,
        fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response.data?.message)
        subscriptonList()
        handleClose()
        
      })
      .catch((error) => {
        console.log("", error);
      })
      :
      axios
      .put(
        `https://app1.crazzyhub.com/api/admin/product-variants-subscription-list/?store_id=${StoreID}&id=${ids}`,
        fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response.data?.message)
        subscriptonList()
        handleClose()
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  const editFunctionality = (event, row) => {
    event.preventDefault();
    console.log("id",row?.id)
    setIds(row?.id)
    setName(row?.subscription_name);
    handleOpen()
  };

  const closeModal=()=>{
    setIds(null)
    setName("");
    handleClose()
  }
  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Product Variant Subscription Plan
          </p>
        </div>
        <div className="m-2">
          <Button variant="outlined" size="small" onClick={handleOpen}>
            + Add Product Variant Subscription{" "}
          </Button>
        </div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 430 }} className="rounded-2xl !border-0">
            <div
              id="child-modal-title "
              className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
            >
              {ids === null ? "Add Product Variant Subscription" : "Update Product Variant Subscription" }
              
            </div>
            <div>Subscription Name</div>
            <TextField
              id="outlined-basic"
              size="small"
              className="!w-[100%] !mt-3"
              onChange={(event) => setName(event.target.value)}
              value={name}
            />
            <Button
              onClick={handleClose}
              variant="contained"
              color="warning"
              className="!py-2 !mt-3"
            >
              CANCEL
            </Button>
            <Button
              variant="contained"
              color="success"
              type="submit"
              className="!py-2 !px-8 !mt-3 bg-yellow-300 !float-right"
              onClick={submitData}
            >
             {ids === null ? "ADD" : "UPDATE"}
            </Button>
          </Box>
        </Modal>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              className="!border-3 !border-black !w-72 mx-3 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
            />
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                {superuserId === "true" ? (
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    STORE NAME
                  </TableCell>
                ) : null}

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SUBSCRIPTION NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    {superuserId === "true" ? (
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        ₹{" "}
                        {row?.store?.store_name ? row?.store?.store_name : "--"}
                      </TableCell>
                    ) : null}

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.subscription_name ? row?.subscription_name : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <BorderColorIcon
                        className="!text-green-500"
                        onClick={(event) => editFunctionality(event, row)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionAdmin;
